<template>
    <div>
        <div class="fixed-top" v-if="fixedBgShow"></div>
        <div class="top-box" :class="{'top-box-height':!sportInfo.calories}">
            <img class="top-box-img" src="@/assets/theme/light/trainPlan/10sportDesc/03bg.png">
            <img class="sport-back" v-if="!fixedBgShow && isShareShow" @click="back"
                 :src="require(`@/assets/theme/light/sport/04sportDesc/01back1.png`)">
            <img class="sport-share" v-if="!fixedBgShow && isShareShow" @click="share"
                 :src="require(`@/assets/theme/light/sport/04sportDesc/03share1.png`)">
            <img class="sport-back" v-if="fixedBgShow && isShareShow" @click="back"
                 :src="require(`@/assets/theme/light/sport/04sportDesc/01back.png`)">
            <img class="sport-share" v-if="fixedBgShow && isShareShow" @click="share"
                 :src="require(`@/assets/theme/light/sport/04sportDesc/03share.png`)">
            <div class="info-box" :class="{'info-box-height':!sportInfo.calories}">
                <div class="info-content">
                    <div class="act-time">{{ SwitchTime24(sportInfo.actTime) }}</div>
                    <div class="capacity" v-if="sportInfo.totalCapacity">{{ sportInfo.totalCapacity }}
                        {{ $t('startTrain.capacity') }}
                    </div>
                    <div class="time-box">{{ sportInfo.startSportTime }} ~ {{ sportInfo.endSportTime }}</div>
                    <div class="rest-time-key">{{ $t('sportTrainDesc.rest') }}</div>
                    <div class="rest-time-value">{{ SwitchTime24(sportInfo.restTime) }}</div>
                    <div v-if="sportInfo.calories">
                        <div class="cal-key">{{ $t('sportTrainDesc.cal') }}</div>
                        <div class="cal-value">{{ sportInfo.calories ? sportInfo.calories : 0 }} <span
                            class="cal-unit">{{ $t('unit.kcal') }}</span></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="action-box">
            <div class="group-item" v-for="(item, i) in actionList">
                <div class="action-title-box">
                    <img class="action-icon" :src="item.bannerUrl">
                    <div class="action-name" v-if="$i18n.locale === 'en'">{{ item.actionNameEn }}</div>
                    <div class="action-name" v-else-if="$i18n.locale === 'ja'">{{ item.actionNameJa }}</div>
                    <div class="action-name" v-else>{{ item.actionName }}</div>
                    <div class="top-capacity" v-if="item.totalCapacity">{{ item.totalCapacity }} {{ item.unit }}</div>
                </div>
                <div class="group-box" :class="{'incomplete': !group.t}"
                     v-for="(group, j) in item.actionList" :key="j">
                    <div class="group-index">{{ j + 1 }}
                    </div>
                    <div class="record-type" v-if="item.recordType == 1">
                        {{ group.w }} {{ item.unit }} × {{ group.f }}
                    </div>
                    <div class="record-type" v-if="item.recordType == 2">
                        {{ SwitchTime24(group.t) }}
                    </div>
                    <div class="record-type" v-if="item.recordType == 3">
                        {{ group.f }} {{ $t('planEdit.frequency') }}
                    </div>
                    <div class="record-type" v-if="item.recordType == 4">
                        {{ group.d }} km
                    </div>
                    <div class="action-time" v-if="group.t">{{ SwitchTime24hms(group.rt) }}</div>
                </div>

            </div>
        </div>
        <div class="chart-box" v-if="hrChartShow">
            <div class="item-box">
                <div class="chart-title">
                    <img class="chart-icon" :src="require(`@/assets/theme/light/sport/04sportDesc/07hr.png`)">
                    {{ $t('sportTrainDesc.hr') }}<span class="chart-unit">（{{ $t('sportTrainDesc.hrUnit') }}）</span>
                </div>
                <div class="chart-math">
                    <van-row>
                        <van-col span="8">
                            <div class="math-item">
                                <div class="total-value-num">{{ sportInfo.maxHeartrate }}</div>
                                <div class="total-key">{{ $t('sportTrainDesc.max') }}</div>
                            </div>
                        </van-col>
                        <van-col span="8">
                            <div class="math-item">
                                <div class="total-value-num">{{ sportInfo.minHeartrate }}</div>
                                <div class="total-key">{{ $t('sportTrainDesc.min') }}</div>
                            </div>
                        </van-col>
                        <van-col span="8">
                            <div class="math-item">
                                <div class="total-value-num">{{ sportInfo.avgHeartrate }}</div>
                                <div class="total-key">{{ $t('sportTrainDesc.avg') }}</div>
                            </div>
                        </van-col>
                    </van-row>
                </div>
                <div id="hr-chart" class="chart"></div>
                <div class="hr-range-box">
                    <div class="hr-line">
                        <div class="hr-line-title">{{$t('sportTrainDesc.hrRange0')}}</div>
                        <div class="hr-line-desc">≥{{ hRangeZoneData[4] }} {{$t('sportTrainDesc.hrUnit')}}</div>
                        <div class="percent">
                            <van-progress :percentage="hRangeData[4]" stroke-width="10"
                                          track-color="var(--bg-color-2)" color="var(--chart-color-3)"/>
                        </div>
                        <div class="hr-line-percent">{{ hRangeData[4] }}%</div>
                        <div class="hr-line-time">{{ hRangeDataTime[4] }}</div>
                    </div>
                    <div class="hr-line">
                        <div class="hr-line-title">{{$t('sportTrainDesc.hrRange1')}}</div>
                        <div class="hr-line-desc">{{ hRangeZoneData[3] }}-{{ hRangeZoneData[4] }} {{$t('sportTrainDesc.hrUnit')}}</div>
                        <div class="percent">
                            <van-progress :percentage="hRangeData[3]" stroke-width="10"
                                          track-color="var(--bg-color-2)" color="var(--chart-color-10)"/>
                        </div>
                        <div class="hr-line-percent">{{ hRangeData[3] }}%</div>
                        <div class="hr-line-time">{{ hRangeDataTime[3] }}</div>
                    </div>
                    <div class="hr-line">
                        <div class="hr-line-title">{{$t('sportTrainDesc.hrRange2')}}</div>
                        <div class="hr-line-desc">{{ hRangeZoneData[2] }}-{{ hRangeZoneData[3] }} {{$t('sportTrainDesc.hrUnit')}}</div>
                        <div class="percent">
                            <van-progress :percentage="hRangeData[2]" stroke-width="10"
                                          track-color="var(--bg-color-2)" color="var(--chart-color-8)"/>
                        </div>
                        <div class="hr-line-percent">{{ hRangeData[2] }}%</div>
                        <div class="hr-line-time">{{ hRangeDataTime[2] }}</div>
                    </div>
                    <div class="hr-line">
                        <div class="hr-line-title">{{$t('sportTrainDesc.hrRange3')}}</div>
                        <div class="hr-line-desc">{{ hRangeZoneData[1] }}-{{ hRangeZoneData[2] }} {{$t('sportTrainDesc.hrUnit')}}</div>
                        <div class="percent">
                            <van-progress :percentage="hRangeData[1]" stroke-width="10"
                                          track-color="var(--bg-color-2)" color="var(--chart-color-3)"/>
                        </div>
                        <div class="hr-line-percent">{{ hRangeData[1] }}%</div>
                        <div class="hr-line-time">{{ hRangeDataTime[1] }}</div>
                    </div>
                    <div class="hr-line">
                        <div class="hr-line-title">{{$t('sportTrainDesc.hrRange4')}}</div>
                        <div class="hr-line-desc">{{ hRangeZoneData[0] }}-{{ hRangeZoneData[1] }} {{$t('sportTrainDesc.hrUnit')}}</div>
                        <div class="percent">
                            <van-progress :percentage="hRangeData[0]" stroke-width="10"
                                          track-color="var(--bg-color-2)" color="var(--chart-color-1)"/>
                        </div>
                        <div class="hr-line-percent">{{ hRangeData[0] }}%</div>
                        <div class="hr-line-time">{{ hRangeDataTime[0] }}</div>
                    </div>
                </div>
                <div class="hr-split-line"></div>
            </div>
        </div>
        <div class="train-box" v-if="trainEffectShow">
            <div class="box-title">{{ $t('sportTrainDesc.trainEffect') }}</div>
            <div class="effect-chart" id="effect-chart"></div>
            <div class="effect-desc">本次爬坡走相比以往重量提升了20%，耐力明显加强，继续保持训练以获得更长久的进步。</div>
        </div>

        <div class="train-box">
            <div class="box-title">{{ $t('sportTrainDesc.trainFeel') }}</div>
            <div class="feel-type-box">
                <van-row>
                    <van-col span="8">
                        <div class="feel-item" :class="{'feel-not-active': sportInfo.trainFeelType!=0}" @click="changeFeelType(0)">
                            <img class="feel-icon" src="@/assets/theme/light/trainPlan/09startTrain/04easy.png">
                            <div class="feel-text">{{ $t('startTrain.easy') }}</div>
                        </div>

                    </van-col>
                    <van-col span="8">
                        <div class="feel-item" :class="{'feel-not-active': sportInfo.trainFeelType!=1}" @click="changeFeelType(1)">
                            <img class="feel-icon" src="@/assets/theme/light/trainPlan/09startTrain/05normal.png">
                            <div class="feel-text">{{ $t('startTrain.normal') }}</div>
                        </div>

                    </van-col>
                    <van-col span="8">
                        <div class="feel-item" :class="{'feel-not-active': sportInfo.trainFeelType !=2}" @click="changeFeelType(2)">
                            <img class="feel-icon" src="@/assets/theme/light/trainPlan/09startTrain/06hard.png">
                            <div class="feel-text">{{ $t('startTrain.hard') }}</div>
                        </div>
                    </van-col>
                </van-row>
                <div class="feel-input-box">
                    <van-field class="feel-input" type="textarea"
                               v-model="sportInfo.trainFeel"
                               :placeholder="$t('startTrain.feelInput')"
                               maxlength="200"
                               rows="2"
                               @blur="confirmFeel"
                    />
                </div>
            </div>
        </div>

        <div class="part-img-box">
            <div class="part-item-title">{{ $t('actionDesc.part') }}</div>
            <div class="part-icon-box">
                <img class="part-icon" src="@/assets/theme/light/trainPlan/10sportDesc/16.svg">
                <img class="part-icon" v-for="item in musclesIcon" :src="item">
            </div>
        </div>

        <div class="from-box">
            <img class="from-icon" v-if="sportInfo.watchName" src="@/assets/theme/light/sport/04sportDesc/14TA700S.png">
            <div class="from-desc" v-if="sportInfo.watchName">{{ $t('sportTrainDesc.dataFrom') }}{{ watchName }}</div>
            <div class="from-desc" v-else>{{ $t('sportTrainDesc.dataFrom') }}Aswear Global APP</div>
        </div>
    </div>
</template>

<script>
import {getSkin} from '@/utils/comment'
import {
    SwitchTime24,
    SwitchTime24hms,
    formatSeconds2
} from "../../utils/dateUtils";
import {WebJSBridge} from "../../utils/JSBridge1";

export default {
    name: 'sportDesc',
    data() {
        return {
            sportId: 0,
            sportInfo: {},
            actionList: [],
            fixedBgShow: false,
            ratio: 1,
            hrChartShow: false,
            hRangeData: [],
            hRangeZoneData: [],
            hRangeDataTime: [],
            trainEffectShow: false,
            trainMuscles: [],
            watchName: 'Syntime4_05A6',
            from: '',
            parent: '',
            isShareShow: true,
            musclesIcon: [],
        }
    },
    mounted() {
        this.ratio = document.body.clientWidth / 375 ? document.body.clientWidth / 375 : 1;
        if (this.$route.query.sportId) {
            this.sportId = this.$route.query.sportId;
            this.getSportTrainById();
        }
        if (this.$route.query.from) {
            this.from = this.$route.query.from;
        }
        if (this.$route.query.parent) {
            this.parent = this.$route.query.parent;
        }
        window.addEventListener('scroll', this.windowScroll);
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.windowScroll);
    },
    methods: {
        back() {
            if (this.parent === 'trainCalendar') {
                this.$router.back();
            } else if (this.from === 'web') {
                this.$router.go(-2)
            } else {
                WebJSBridge.call("closeWeb", null, function (res) {
                });
            }
        },
        windowScroll() {
            let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            if (scrollTop > 88 * this.ratio) {
                this.fixedBgShow = true;
            } else {
                this.fixedBgShow = false;
            }
        },
        getSportTrainById() {
            this.$api.trainPlan.getSportTrainById({
                sportId: this.sportId
            }).then(res => {
                this.sportInfo = res.info;
                this.actionList = res.info.actionList;
                this.dealActionList();
                this.dealHr();
                this.drawTrainEffect();
                let muscles = this.sportInfo.trainMuscles.split(',');
                this.musclesIcon = [];
                for (let i = 0; i < muscles.length; i++) {
                    this.musclesIcon.push(require('@/assets/theme/light/trainPlan/10sportDesc/'+muscles[i]+'.svg'));
                }
            })
        },
        SwitchTime24(num) {
            if (!num) {
                return '00:00:00'
            }
            return SwitchTime24(num)
        },
        SwitchTime24hms(num) {
            return SwitchTime24hms(num)
        },
        dealActionList() {
            let actionGroup = JSON.parse(this.sportInfo.actionListGroup);
            let trainMuscles = [];
            // 将 actionId 字符串解析为数组
            const actionIdArray = this.sportInfo.actionListId.split(',').map(Number);

            // 根据 actionIdArray 的顺序对 actionList 进行排序
            this.actionList.sort((a, b) => {
                return actionIdArray.indexOf(a.actionId) - actionIdArray.indexOf(b.actionId);
            });
            let actionListUnit = [];
            if (this.sportInfo.actionListUnit) {
                actionListUnit = this.sportInfo.actionListUnit.split(',')
            }
            for (let i = 0; i < this.actionList.length; i++) {
                if (actionListUnit.length > 0) {
                    this.actionList[i].unit = actionListUnit[i]
                }
                this.actionList[i].actionList = actionGroup[i];
                let trainMusclesItem = this.actionList[i].trainMuscles.split(',');
                trainMuscles.push(...trainMusclesItem);
                if (this.actionList[i].recordType === 1) {
                    let capacity = 0;
                    for (let j = 0; j < this.actionList[i].actionList.length; j++) {
                        capacity += parseInt(this.actionList[i].actionList[j].f) * parseInt(this.actionList[i].actionList[j].w);
                    }
                    this.actionList[i].totalCapacity = capacity;
                }
            }
            this.trainMuscles = [...new Set(trainMuscles)]
            console.log(this.actionList)
        },
        dealHr() {
            if (this.sportInfo.heartrateData) {
                this.hrChartShow = true;
            } else {
                return;
            }
            if (this.sportInfo.heartrateRangeData) {
                this.hRangeData = [];
                this.hRangeDataTime = [];
                let hrr = this.sportInfo.heartrateRangeData.split(',');
                if (this.sportInfo.heartrateRangeZoneData) {
                    this.hRangeZoneData = this.sportInfo.heartrateRangeZoneData.split(',');
                }
                for (let i = 0; i < hrr.length; i++) {
                    this.hRangeData.push(parseInt(parseInt(hrr[i]) / this.sportInfo.actTime * 100));
                    if (hrr[i] == 0) {
                        this.hRangeDataTime.push('00:00:00')
                    } else {
                        this.hRangeDataTime.push(formatSeconds2(hrr[i]))
                    }
                }
            }
            let odata = this.sportInfo.heartrateData.split(',');
            if (odata.length == 0 || this.checkArrValid(odata)) {
                return;
            }
            let timeStep = this.is806 ? 60 : 20;
            let count = Math.floor(this.sportInfo.actTime / timeStep);
            let ndata = [], xData = [];
            for (let i = 0; i < count; i++) {
                let value = 0;
                if (i >= odata.length) {
                    value = Number(odata[odata.length - 1]);
                } else {
                    value = Number(odata[i]);
                }
                xData.push(formatSeconds2(timeStep * (i + 1)));
                ndata.push(value);
            }
            let colorGroup = [];
            let chartId;
            colorGroup = [getSkin('--chart-color-3'), getSkin('--bg-color-2'), getSkin('--chart-color-19')];
            chartId = 'hr-chart';
            this.$nextTick(function () {
                this.drawChart(chartId, '心率', ndata, xData, colorGroup)
            })
        },
        // 判断数组是否全为0
        checkArrValid(arr) {
            let inValid = true;
            for (let i = 0; i < arr.length; i++) {
                if (arr[i] != 0) {
                    inValid = false;
                }
            }
            return inValid;
        },
        // 画Hr
        drawChart(id, type, data, xdata, colorGroup) {
            let yAxis = {
                type: 'value',
                position: 'left',
                splitNumber: 4,
                boundaryGap: [0, '10%'],
                splitLine: {
                    lineStyle: {
                        type: 'dotted',
                        color: getSkin('--line-color-3')
                    }
                },
                axisLabel: {
                    fontSize: 12,
                    color: getSkin('--text-color-3'),
                    showMinLabel: false,
                    formatter: function (value, index) {
                        return value;
                    }
                },
            };
            let myChart = this.$echarts.init(document.getElementById('hr-chart'));
            myChart.setOption({
                grid: {
                    top: 15 * this.ratio,
                    bottom: 35 * this.ratio,
                    left: 53 * this.ratio,
                    right: 26 * this.ratio
                },
                dataZoom: { // 放大和缩放
                    type: 'inside'
                },
                tooltip: {
                    backgroundColor: getSkin('--bg-color-2'),
                    trigger: 'axis',
                    axisPointer: {
                        type: 'line'
                    },
                    formatter: function (params, ticket, callback) {
                        let item = params[0];
                        let html = '';
                        let value = item.data;
                        html += '<div style="font-size:12px;color: ' + getSkin('--text-color-3') + '">' + item.axisValue + '</div>'
                        html += '<div style="font-size:12px;color: ' + getSkin('--text-color-3') + '">' + item.seriesName + '：<span style="font-size:19px;font-family:PP;color: ' + getSkin('--text-color-1') + '">' + value + '</span></div>'
                        return html
                    }
                },
                xAxis: {
                    type: 'category',
                    axisLine: {
                        lineStyle: {
                            color: getSkin('--line-color-2')
                        }
                    },
                    axisLabel: {
                        fontSize: 12,
                        color: getSkin('--text-color-3'),
                        interval: Math.floor(xdata.length / 2) - 2
                    },
                    axisTick: {
                        show: false
                    },
                    data: xdata
                },
                yAxis: yAxis,
                series: [
                    {
                        data: data,
                        name: type,
                        type: 'line',
                        symbol: 'none',
                        color: colorGroup[0],
                        smooth: true,
                        areaStyle: {
                            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                {
                                    offset: 1,
                                    color: colorGroup[1]
                                },
                                {
                                    offset: 0,
                                    color: colorGroup[2]
                                }
                            ])
                        },
                    }
                ]
            }, true);
        },
        // 画六边形图
        drawTrainEffect() {
            if (this.sportInfo.trainEffect) {
                this.trainEffectShow = true;
            } else {
                this.trainEffectShow = false;
                return;
            }
            let trainEffect = this.sportInfo.trainEffect.split(',');
            let option = {
                legend: {
                    show: false
                },
                radar: {
                    center: ['50%', '50%'],
                    radius: 91 * this.ratio,
                    axisName: {
                        color: '#fff',
                        backgroundColor: '#666',
                        borderRadius: 3,
                        padding: [3, 5]
                    },
                    indicator: [
                        { name: this.$t('sportTrainDesc.effect0'), max: 10 },
                        { name: this.$t('sportTrainDesc.effect1'), max: 10 },
                        { name: this.$t('sportTrainDesc.effect2'), max: 10 },
                        { name: this.$t('sportTrainDesc.effect3'), max: 10 },
                        { name: this.$t('sportTrainDesc.effect4'), max: 10 }
                    ]
                },
                series: [
                    {
                        name: 'Budget vs spending',
                        type: 'radar',
                        color: '#FF917C',
                        data: [
                            {
                                value: trainEffect,
                                name: 'Actual Spending',
                                label: {
                                    show: true,
                                    formatter: function (params) {
                                        return params.value;
                                    }
                                },
                                areaStyle: {
                                    color: this.$echarts.graphic.RadialGradient(0.1, 0.6, 1, [
                                        {
                                            color: 'rgba(255, 145, 124, 0.1)',
                                            offset: 0
                                        },
                                        {
                                            color: 'rgba(255, 145, 124, 0.9)',
                                            offset: 1
                                        }
                                    ])
                                }
                            }
                        ]
                    }
                ]
            };
            this.$nextTick(function () {
                let myChart = this.$echarts.init(document.getElementById('effect-chart'));
                myChart.setOption(option);
            })

        },
        changeFeelType(num) {
            this.sportInfo.trainFeelType = num;
            this.$api.trainPlan.updateFeel({
                sportId: this.sportInfo.sportId,
                trainFeelType: num,
                trainFeel: this.sportInfo.trainFeel
            })
        },
        confirmFeel() {
            this.$api.trainPlan.updateFeel({
                sportId: this.sportInfo.sportId,
                trainFeelType: this.sportInfo.trainFeelType,
                trainFeel: this.sportInfo.trainFeel
            })
        },
        share() {
            this.isShareShow = false;
            let _this = this;
            WebJSBridge.call("shareReport", null, function (res) {
                console.log("recieve callback")
                console.log(res)
                _this.isShareShow = true
            });
        }
    }
}
</script>

<style scoped>
.top-bg {
    width: 375px;
    position: absolute;
    top: 0;
    z-index: -1;
}

.banner {
    background-color: transparent;
}

.back-icon {
    width: 36px;
    height: 36px;
    margin: 11px 16px;
    float: left;
}

.right-icon {
    float: right;
}

.info-box {
    width: 345px;
    height: 157px;
    background: var(--bg-color-2);
    border-radius: 13px 13px 13px 13px;
    z-index: 1;
    position: absolute;
    top: 188px;
    left: 15px;
}

.top-box {
    position: relative;
    width: 375px;
    height: 355px;
}

.info-content {
    position: relative;
    width: 100%;
    height: 100%;
}

.act-time {
    font-weight: 500;
    font-size: 29px;
    color: var(--text-color-1);
    font-family: PP;
    position: absolute;
    left: 25px;
    top: 14px;
}

.capacity {
    font-size: 15px;
    color: var(--text-color-1);
    position: absolute;
    right: 14px;
    top: 24px;
}

.time-box {
    font-size: 13px;
    color: var(--text-color-3);
    position: absolute;
    left: 24px;
    top: 56px;
}

.rest-time-key {
    font-size: 13px;
    color: var(--text-color-2);
    position: absolute;
    left: 25px;
    top: 88px;
    line-height: 19px;
}

.rest-time-value {
    font-size: 19px;
    color: var(--text-color-1);
    position: absolute;
    left: 97px;
    top: 88px;
    font-family: PP;
    line-height: 19px;
}

.cal-key {
    font-size: 13px;
    color: var(--text-color-2);
    position: absolute;
    left: 25px;
    top: 122px;
}

.cal-value {
    font-size: 19px;
    color: var(--text-color-1);
    position: absolute;
    left: 97px;
    top: 116px;
    font-family: PP;
}

.cal-unit {
    font-size: 12px;
    color: var(--text-color-3);
}

.action-box {
    width: 345px;
    border-radius: 13px 13px 13px 13px;
    margin: 0 auto 10px;
    background: var(--bg-color-2);
}

.action-title-box {
    width: 345px;
    height: 61px;
    position: relative;
}

.action-icon {
    width: 46px;
    position: absolute;
    top: 16px;
    left: 15px;
}

.action-name {
    font-weight: 400;
    font-size: 17px;
    color: var(--text-color-1);
    position: absolute;
    left: 71px;
    top: 18px;
}

.top-capacity {
    font-size: 13px;
    color: var(--text-color-2);
    position: absolute;
    left: 71px;
    top: 43px;
}

.group-box {
    width: calc(100% - 71px);
    margin-left: 71px;
    font-size: 13px;
    color: var(--text-color-1);
    font-family: PP;
    height: 33px;
}

.group-index {
    width: 20px;
    text-align: center;
    display: inline-block;
}

.record-type {
    display: inline-block;
    width: 126px;
    margin-left: 10px;
}

.action-time {
    color: var(--text-color-2);
    display: inline-block;
}

.incomplete {
    color: var(--text-color-3);
}

.fixed-top {
    height: 88px;
    width: 100%;
    background-color: var(--bg-color-2);
    position: fixed;
    top: 0px;
    z-index: 111;
}

.sport-back {
    width: 40px;
    position: fixed;
    top: 48px;
    left: 20px;
    z-index: 1111;
}

.sport-share {
    width: 40px;
    position: fixed;
    top: 48px;
    left: 319px;
    z-index: 1111;
}

.top-box-img {
    width: 100%;
}


.chart-box {
    width: 345px;
    background: var(--bg-color-2);
    border-radius: 13px 13px 13px 13px;
    margin: 10px auto 0;
}

.chart-icon {
    width: 18px;
    vertical-align: bottom;
}

.chart-title {
    font-size: 14px;
    color: var(--text-color-1);
    padding-top: 12px;
    margin-left: 15px;
}

.chart-unit {
    font-size: 12px;
    color: var(--text-color-2);
}

.math-item {
    text-align: center;
    margin-top: 11px;
}

.chart {
    height: 176px;
    width: 100%;
}

.hr-range-box {
    width: 315px;
    height: 270px;
    background: var(--bg-color-1);
    border-radius: 13px 13px 13px 13px;
    margin: 0 auto;
}

.hr-line {
    width: 100%;
    height: 51px;
    position: relative;
}

.hr-line-title {
    font-size: 15px;
    color: var(--text-color-1);
    position: absolute;
    top: 14px;
    left: 19px;
}

.hr-line-desc {
    font-size: 13px;
    color: var(--text-color-2);
    position: absolute;
    top: 34px;
    left: 19px;
}


.percent {
    width: 200px;
    height: 10px;
    position: absolute;
    right: 23px;
    top: 17px;
    overflow: hidden;
}

/deep/ .van-progress__pivot {
    display: none !important;
}

/deep/ .van-progress__portion {
    border-radius: 10px;
}

/deep/ .van-progress {
    border-radius: 10px;
}

.hr-line-percent {
    font-family: PP;
    font-size: 15px;
    color: var(--text-color-1);
    position: absolute;
    right: 23px;
    top: 29px;
}

.hr-line-time {
    font-size: 13px;
    color: var(--text-color-2);
    position: absolute;
    top: 32px;
    right: 69px;
}

.hr-split-line {
    width: 311px;
    border-bottom: 1px solid var(--bg-color-1);
    margin: 20px auto 4px;
}


.total-info {
    width: 315px;
    background: var(--bg-color-1);
    border-radius: 13px 13px 13px 13px;
    margin: 19px auto 0;
    padding-bottom: 15px;
}

.total-item {
    margin-top: 10px;
    text-align: center;
}

.total-van-row .total-item {
    /*margin-left: 10px;*/
}

.total-value {
    font-size: 12px;
    color: var(--text-color-3);
}

.total-value-num {
    font-size: 19px;
    font-family: PP;
    color: var(--text-color-1);
    margin-right: 2px;
}

.total-key {
    font-size: 13px;
    color: var(--text-color-2);
}

.train-box {
    width: 345px;
    background: var(--bg-color-2);
    border-radius: 13px 13px 13px 13px;
    padding-bottom: 14px;
}

.box-title {
    font-size: 15px;
    color: var(--text-color-1);
    padding: 14px 16px;
}

.train-box {
    margin: 10px auto;
}

.effect-chart {
    width: 345px;
    height: 250px;
    margin: 0 auto;
}

.effect-desc {
    width: 280px;
    background: var(--bg-color-1);
    border-radius: 8px 8px 8px 8px;
    padding: 11px 13px;
    margin: 0 auto;
    font-size: 13px;
    color: var(--text-color-1);
    line-height: 20px;
}


.feel-icon {
    width: 35px;
    margin-top: 20px;
}

.feel-item {
    text-align: center;
    font-size: 13px;
    line-height: 20px;
    color: var(--text-color-1);
}

.feel-not-active {
    opacity: 0.2;
}

.feel-input-box {
    width: 315px;
    margin: 0 auto 5px;
}

/deep/ .feel-input-box .van-field__control {
    background: var(--bg-color-1);
    border-radius: 8px 8px 8px 8px;
    padding: 11px 9px;
}

/deep/ .feel-input-box .van-field__control::placeholder {
    color: var(--text-color-3);
}

.info-box-height {
    height: 130px;
}

.top-box-height {
    height: 328px;
}

.from-box {
    text-align: center;
    margin-bottom: 26px;
    margin-top: 21px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.from-icon {
    width: 24px;
}

.from-desc {
    font-size: 13px;
    color: var(--text-color-2);
}


.part-icon-box {
    width: 245px;
    margin: 15px 50px 0 50px;
    position: relative;
}

.part-icon {
    width: 245px;
    position: absolute;
}


.part-img-box {
    width: 345px;
    height: 274px;
    background: var(--bg-color-2);
    border-radius: 13px 13px 13px 13px;
    margin: 10px auto;
}

.part-item-title {
    font-size: 15px;
    color: var(--text-color-1);
    margin-left: 15px;
    padding-top: 16px;
}

/deep/ .van-cell {
    background-color: var(--bg-color-2);
}
</style>


// WEBPACK FOOTER //
// src/views/trainPlan/10sportDesc.vue